import { css } from 'styled-components';

export const TaskIntensityStyles = css`
  .b-sch-event-wrap.task-intensity {
    top: 34px;
    height: 6px;

    .b-sch-event {
      border-radius: 0;
      width: 100%;
      background-color: transparent;
      &:hover {
        background-color: transparent;
      }
      .intensity-bar {
        height: 6px;
      }
      .level-1 {
        background-color: var(--yellow-20);
      }
      .level-2 {
        background-color: var(--yellow-20);
      }
      .level-3 {
        background-color: var(--yellow-30);
      }
      .level-4 {
        background-color: var(--yellow-30);
      }
      .level-5 {
        background-color: var(--yellow-40);
      }
      .level-6 {
        background-color: var(--yellow-40);
      }
      .level-7 {
        background-color: var(--yellow-50);
      }
      .level-8 {
        background-color: var(--yellow-50);
      }
      .level-9 {
        background-color: var(--yellow-60);
      }
    }
  }
`;
